import React from 'react';
import { Lightbulb } from 'lucide-react';
import FactCard from './FactCard';

const FactsSection = () => {
  const facts = [
    {
      text: 'El autismo no es una enfermedad ni tiene cura, pero con apoyo puede mejorar mucho la calidad de vida.'
    },
    {
      text: 'Puede aparecer en niños, jóvenes o adultos, aunque muchas veces se detecta tarde.'
    },
    {
      text: 'Cada persona con autismo es diferente. No todos tienen los mismos síntomas ni el mismo nivel de apoyo.'
    },
    {
      text: 'Las personas autistas sí sienten emociones, aunque a veces les cuesta expresarlas.'
    },
    {
      text: 'Las personas autistas no necesariamente tienen discapacidad intelectual; muchas tienen inteligencia promedio o alta, e incluso habilidades especiales.'
    },
    {
      text: 'No se puede saber si una persona tiene autismo solo con verla; se necesita una evaluación especializada.'
    },
    {
      text: 'El autismo no siempre se presenta igual todos los días. Sus manifestaciones pueden variar según el entorno o el estado emocional.'
    },
    {
      text: 'El autismo no está causado por la crianza ni por la forma en que se educa a un niño.'
    },
    {
      text: 'Algunas personas autistas necesitan apoyo constante, pero otras pueden vivir de manera independiente y tomar sus propias decisiones.'
    },
    {
      text: 'Las necesidades de apoyo pueden cambiar con el tiempo. Lo que un niño necesita hoy puede no ser igual en el futuro.'
    }
  ];

  return (
    <section id="facts" className="py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <div className="inline-flex items-center justify-center mb-4">
            <Lightbulb className="w-8 h-8 text-purple-500" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-800 mb-4">¿Sabías que...?</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Conoce algunos datos que ayudan a entender mejor el autismo y desmontar mitos comunes:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {facts.map((fact, index) => (
            <FactCard 
              key={index}
              text={fact.text}
              index={index + 1}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FactsSection;
